module.exports = __webpack_public_path__ + "img/ordenes.7689b284.svg";